module.exports = __webpack_public_path__ + "img/login_background-3.9a34dd0d.svg";